import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { getPAJAC030Goods, getPAJAC050 } from '../../../../services/Api';
import { formatDate, formatDateTime, formatNumberWithCommas } from '../../../../utils';
const PAJAC040 = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const paramsPm = searchParams.get('pm');
    const paramsRc = searchParams.get('rc');
    const [data, setData] = useState({});
    // Giá 덴탈잡 đang áp dụng từ DB (tblGoods_Price), key = LegacyCode (mã cũ, khớp với goodCode của trang)
    const [goodsByLegacyCode, setGoodsByLegacyCode] = useState({});

    const productData = {
        banner: [
            {
                goodCode: '011',
                name: '비즈니스 배너',
                price: 950000,
                duration: 7,
            },
            {
                goodCode: '002',
                name: '그랜드 배너\n(채용소식 포함)',
                price: 400000,
                duration: 7,
            },
            {
                goodCode: '6000',
                name: '고정옵션\n(그랜드 배너)',
                price: 60000,
                duration: 7,
            },
            {
                goodCode: '0023',
                name: '그랜드 배너\n(채용광고 디자인 서비스 포함)',
                price: 0,
                duration: 7,
            },
            {
                goodCode: '003',
                name: '프리미엄 배너\n(채용소식 포함)',
                price: 210000,
                duration: 7,
            },
            {
                goodCode: '7000',
                name: '고정옵션\n(프리미엄 배너)',
                price: 60000,
                duration: 7,
            },
            {
                goodCode: '0033',
                name: '프리미엄 배너\n(채용광고 디자인 서비스 포함)',
                price: 0,
                duration: 7,
            },
            {
                goodCode: '010',
                name: '기업 배너',
                price: 440000,
                duration: 7,
            },
            {
                goodCode: '008',
                name: '핫리쿠르트 배너\n(채용소식 포함)',
                price: 135000,
                duration: 7,
            },
            {
                goodCode: '4000',
                name: '고정옵션\n(핫리쿠르트 배너)',
                price: 60000,
                duration: 7,
            },
            {
                goodCode: '001',
                name: '채용소식',
                price: 60000,
                duration: 14,
            },
        ],
        fixed: [
            {
                goodCode: '5000',
                name: '고정옵션\n(채용소식)',
                price: 60000,
                duration: 7,
            },
            {
                goodCode: '5002',
                name: '고정옵션\n(채용소식)',
                price: 120000,
                duration: 14,
            },
        ],
        highlight: [
            {
                goodCode: '1000',
                name: '하이라이트 강조 1주',
                price: 12000,
                duration: 7,
            },
            {
                goodCode: '1500',
                name: '하이라이트 강조 2주',
                price: 18000,
                duration: 14,
            },
            {
                goodCode: '2000',
                name: '컬러 강조 1주',
                price: 10000,
                duration: 7,
            },
            {
                goodCode: '2500',
                name: '컬러 강조 2주',
                price: 15000,
                duration: 14,
            },
            {
                goodCode: '3010',
                name: '아이콘 강조 1주 (주목)',
                price: 8000,
                duration: 7,
            },
            {
                goodCode: '3020',
                name: '아이콘 강조 1주 (HOT)',
                price: 8000,
                duration: 7,
            },
            {
                goodCode: '3510',
                name: '아이콘 강조 2주 (주목)',
                price: 12000,
                duration: 14,
            },
            {
                goodCode: '3520',
                name: '아이콘 강조 2주 (HOT)',
                price: 12000,
                duration: 14,
            },
        ],
    };

    // Giá lấy từ DB; sản phẩm chưa có trong bảng (5002 고정옵션 14일, 아이콘 강조...) giữ giá cố định ở trên
    const findProduct = (goodCode) => {
        const allProducts = [...productData.banner, ...productData.fixed, ...productData.highlight];
        const product = allProducts.find((item) => item.goodCode === goodCode);
        const goods = goodsByLegacyCode[goodCode];

        if (!product || !goods || goods.priceDJ == null) return product;
        return { ...product, price: Number(goods.priceDJ) };
    };

    const payItems = [
        [data?.bannerCode, data?.bannerPayMethod],
        [data?.bannerFixCode, data?.bannerFixPayMethod],
        [data?.fixJumpUpCode, data?.fixJumpUpPayMethod],
        [data?.extraCode, data?.extraPayMethod],
    ];
    const totalPrice = payItems.reduce(
        (total, [code, payMethod]) => (code && payMethod === 'BANK' ? total + (findProduct(code)?.price || 0) : total),
        0,
    );

    useEffect(() => {
        getPAJAC030Goods()
            .then(({ data }) => {
                setGoodsByLegacyCode(
                    Object.fromEntries(
                        (data || []).filter((goods) => goods.legacyCode).map((goods) => [goods.legacyCode, goods]),
                    ),
                );
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!paramsPm && !paramsRc) {
                    setTimeout(() => {
                        navigate('/');
                    });
                } else {
                    const response = await getPAJAC050(paramsRc, paramsPm);
                    const data = response.data;
                    setData(data);
                }
            } catch (error) {
                navigate('/');
                console.error(error);
            }
        };
        fetchData();
        // eslint-disable-next-line
    }, [paramsPm, paramsRc, navigate]);

    return (
        <>
            <div className="cmpl__top">
                <img src="./images/PAJAC040/icon-check.png" alt="" />
                <div className="cmpl__block">
                    <span className="bold">광고상품 결제가 완료되었습니다!</span>
                    <span>채용공고 관리 및 결제 관리에서 상세 내역을 확인하실 수 있습니다.</span>
                    <span>
                        <b>주문일자</b> : {formatDateTime(data?.addDate)}
                    </span>
                </div>
            </div>
            <table className="cmpl__table">
                <tbody>
                    <tr>
                        <th>채용공고</th>
                        <td colSpan={4}>{data?.title}</td>
                    </tr>
                    <tr>
                        <th>채용기간</th>
                        <td colSpan={4}>
                            {formatDate(data?.recruitFrom)} ~ {formatDate(data?.recruitEnd)}
                        </td>
                    </tr>
                    <tr className="table-bill-head">
                        <th style={{ width: '25%' }}>상품명</th>
                        <th style={{ width: '10%' }}>기간</th>
                        <th style={{ width: '25%' }}>공고기간</th>
                        <th style={{ width: '20%' }}>
                            [덴탈잡 이용권]
                            <br />
                            적용 여부
                        </th>
                        <th style={{ width: '20%' }}>결제금액</th>
                    </tr>
                    {data?.bannerCode !== null && (
                        <tr className="table-bill-data table-bill-contents">
                            <td>{findProduct(data.bannerCode)?.name || ''}</td>
                            <td>{findProduct(data.bannerCode)?.duration || ''}일</td>
                            <td>
                                {formatDate(data?.bannerStartDate)} ~ {formatDate(data?.bannerEndDate)}
                            </td>
                            <td>
                                {data?.bannerPayMethod === 'BANK'
                                    ? '-'
                                    : data?.bannerPayMethod === 'EMTICKET'
                                        ? 'O'
                                        : ''}
                            </td>
                            <td>
                                {data?.bannerPayMethod === 'BANK'
                                    ? formatNumberWithCommas(findProduct(data.bannerCode)?.price)
                                    : data?.bannerPayMethod === 'EMTICKET'
                                        ? '0'
                                        : ''}
                                원
                            </td>
                        </tr>
                    )}
                    {data?.bannerFixCode !== null && (
                        <tr className="table-bill-data table-bill-contents">
                            <td>{findProduct(data.bannerFixCode)?.name || ''}</td>
                            <td>{findProduct(data.bannerFixCode)?.duration || ''}일</td>
                            <td>
                                {formatDate(data?.bannerStartDate)} ~ {formatDate(data?.bannerEndDate)}
                            </td>
                            <td>
                                {data?.bannerFixPayMethod === 'BANK'
                                    ? '-'
                                    : data?.bannerFixPayMethod === 'EMTICKET'
                                        ? 'O'
                                        : ''}
                            </td>
                            <td>
                                {data?.bannerFixPayMethod === 'BANK'
                                    ? formatNumberWithCommas(findProduct(data.bannerFixCode)?.price)
                                    : data?.bannerFixPayMethod === 'EMTICKET'
                                        ? '0'
                                        : ''}
                                원
                            </td>
                        </tr>
                    )}
                    {data?.fixJumpUpCode !== null && (
                        <tr className="table-bill-data table-bill-contents">
                            <td>{findProduct(data.fixJumpUpCode)?.name || ''}</td>
                            <td>{findProduct(data.fixJumpUpCode)?.duration || ''}일</td>
                            <td>
                                {formatDate(data?.fixJumpUpStartDate)} ~ {formatDate(data?.fixJumpUpEndDate)}
                            </td>
                            <td>
                                {data?.fixJumpUpPayMethod === 'BANK'
                                    ? '-'
                                    : data?.fixJumpUpPayMethod === 'EMTICKET'
                                        ? 'O'
                                        : ''}
                            </td>
                            <td>
                                {data?.fixJumpUpPayMethod === 'BANK'
                                    ? formatNumberWithCommas(findProduct(data.fixJumpUpCode)?.price)
                                    : data?.fixJumpUpPayMethod === 'EMTICKET'
                                        ? '0'
                                        : ''}
                                원
                            </td>
                        </tr>
                    )}
                    {data?.extraCode !== null && (
                        <tr className="table-bill-data table-bill-contents">
                            <td>{findProduct(data.extraCode)?.name || ''}</td>
                            <td>{findProduct(data.extraCode)?.duration || ''}일</td>
                            <td>
                                {formatDate(data?.extraStartDate)} ~ {formatDate(data?.extraEndDate)}
                            </td>
                            <td>
                                {data?.extraPayMethod === 'BANK' ? '-' : data?.extraPayMethod === 'EMTICKET' ? 'O' : ''}
                            </td>
                            <td>
                                {data?.extraPayMethod === 'BANK'
                                    ? formatNumberWithCommas(findProduct(data.extraCode)?.price)
                                    : data?.extraPayMethod === 'EMTICKET'
                                        ? '0'
                                        : ''}
                                원
                            </td>
                        </tr>
                    )}
                    <tr className="table-bill-data">
                        <th>결제 방법</th>
                        {data?.bannerPayMethod === 'EMTICKET' || data?.fixJumpUpPayMethod === 'EMTICKET' || data?.extraPayMethod === 'EMTICKET' ? (
                            <td colSpan={2}>덴탈잡 이용권</td>
                        ) : (
                            <td colSpan={2}>
                                {data?.vactBankCode !== '' && data?.vactBankCode !== null && (
                                    <>
                                        가상계좌
                                        <br />
                                        입금계좌: {data?.vactBankCode} {data?.vactNum}
                                        <br />
                                        입금기한: {formatDate(data?.vactDate, 'YYYYMMDD')} 까지
                                    </>
                                )}
                                {data?.cardBankCode !== '' && data?.cardBankCode !== null && (
                                    <>
                                        카드 <br /> 카드번호: {data?.cardNum}
                                    </>
                                )}
                            </td>
                        )}

                        <th>결제금액</th>
                        <td style={{ textAlign: 'end' }}>{formatNumberWithCommas(totalPrice)}원</td>
                    </tr>
                </tbody>
            </table>
            <div className="dntInf__btbx">
                <Link to="/pajac010" type="button" className="rsm-mng__btn">
                    목록
                </Link>
            </div>
        </>
    );
};
export default PAJAC040;
